export default "/minus.80a13a48844a4276fbf650bd5e668974.svg";